/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Dialog, Divider } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import carImage from "../../assets/img/car_12.png";
import confirmation_group from "../../assets/img/confirmation_group.png";

import { confirmRegistration } from "../../services/auth";
// import SINGUP_BACKGROUND from "../../assets/img/landing_main_background.png";

const useStyles = makeStyles(() =>
  createStyles({
    container85: {
      padding: "0px",
      minWidth: "541px",
      minHeight: "550px",
      backgroundSize: "cover",
      backgroundColor: "#FDFDFD",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // borderRadius: "24px",
      // boxShadow: "0px 28px 24px 0px rgba(34, 51, 68, 0.19)",
    },
    confirmRegistration: {
      background: "#fff",
      width: "100%",
      padding: "40px 40px",
      marginTop: "20px",
    },
    insideContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // justifyContent: "center",
      textAlign: "center",
      width: "100%",
    },
    projectTitle: {
      marginBottom: "15px",
      color: "#000",
      textAlign: "cente",
      // fontFamily: "Barlow",
      fontFamily: "IBM Plex Sans",
      fontSize: "30px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "39px" /* 130% */,
      letterSpacing: "-0.33px",
    },
    colorGray: {
      // width: "461px",
      // height: "21px",
      color: "#8D8E8F",
      textAlign: "center",
      // fontFamily: "Barlow",
      fontFamily: "IBM Plex Sans",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "300",
      lineHeight: "130%",
      marginBottom: "0px",
    },
    endLine: {
      width: "460px",
      color: "#000",
      textAlign: "center",
      // fontFamily: "Barlow",
      fontFamily: "IBM Plex Sans",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "300",
      lineHeight: "130%",
      textTransform: "capitalize",
      marginTop: "20px",
    },
  })
);

const ConfirmRegistration = React.memo(({ open, handleClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [checkPasswordExpiry, setCheckPasswordExpiry] = useState(false);

  async function checkPasswordIsExpired() {
    const isExpired = await dispatch(confirmRegistration());

    if (isExpired) {
      setCheckPasswordExpiry(true);
    } else {
      setCheckPasswordExpiry(false);
    }
  }

  useEffect(() => {
    checkPasswordIsExpired();
  }, [dispatch]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "24px",
          boxShadow: "0px 28px 24px 0px rgba(34, 51, 68, 0.19)",
        },
        "& .MuiBackdrop-root": { background: "transparent", backdropFilter: "blur(10px)" },
      }}
    >
      <Grid container className={classes.container85}>
        <Grid item xs={12} sm={12} className={classes.confirmRegistration}>
          {!checkPasswordExpiry && <Typography component="h1">Password Expired</Typography>}

          {checkPasswordExpiry && (
            <Typography component="div" className={classes.insideContainer}>
              <div
                style={{
                  width: "213.014px",
                  height: "121.258px",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "-30px",
                }}
              >
                <img
                  src={confirmation_group}
                  alt="car"
                  style={{
                    width: "90%",
                    height: "90%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div
                style={{
                  width: "347.591px",
                  height: "156.012px",
                  transform: "rotate(-2.346deg)",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={carImage}
                  alt="car"
                  style={{
                    width: "90%",
                    height: "90%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <Typography variant="h2" className={classes.projectTitle}>
                Registration confirmation
              </Typography>
              <Typography component="p" className={classes.colorGray}>
                You have successfully confirmed your registration.
              </Typography>
              <Typography component="p" className={classes.colorGray}>
                Please note that you will still not be able to login into your account.
              </Typography>
              <Divider
                variant="middle"
                flexItem
                sx={{ marginTop: "20px", width: "176px", alignSelf: "center" }}
              />
              <Typography component="p" className={classes.endLine}>
                Our account manager will contact you with further information about the next steps.
              </Typography>
            </Typography>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
});

export default ConfirmRegistration;
